/**
 * @Author: zpc
 * @Description:
 * @DateTime: Created in 2022-03-10
 */

 import {IconBtnItem} from "src/components/iconBtnGroup/iconBtnGroup";
 import {ColDefCustom, default as AgGridVueCustomTsx} from "src/components/agGridCustom/agGridVueCustomTsx";
 import _ from 'lodash'
 import ListPageService from 'src/types/ListPage';
 import override from "src/dectorators/override";
 import {QueryFormVOI} from "src/components/queryForm/queryForm";
 import EnumStationType from 'src/enums/enumStationType';
 import DatePicker from 'src/types/iview/DatePicker';
 import SerialNumberLog from '../serialNumberLog';
 import softwareSecretKeyApi, { softwareSecretKeyDOI } from '../api/softwareSecretKeyApi';
 
 export default class SerialNumberLogService extends ListPageService {
     ctx: SerialNumberLog;
 
     constructor (ctx: SerialNumberLog) {
        super()
        this.ctx = ctx
     }
 
     @override
     createColumns (): ColDefCustom [] {
        return [
            {
                headerName: 'cpucode',
                field: 'cpucode',
                minWidth: 160
            },
            {
                headerName: '序列号',
                field: 'serial_number',
                minWidth: 160
            },
            {
                headerName: '操作人',
                field: 'user_name',
                minWidth: 160
            },
            {
               headerName: '时间',
               field: 'time',
               minWidth: 160
            }
        ]
     }
 
     @override
     createBtnGroup (): Array<IconBtnItem> {
        return []
     }

     @override
     initSearchParams (): void {
        this.ctx.searchParams = {
            page_index: this.ctx.currentPage,
            page_size: this.ctx.pageSize,
        }
        this.ctx.currentPage = 1
     }
 
     @override
     async searchTable () {
         let ctx = this.ctx
         let ag = (this.ctx.$refs.ag) as AgGridVueCustomTsx
         ag.showLoading()
         let {code, data} = await softwareSecretKeyApi.searchLog({
            page_size: ctx.pageSize,
            page_index: ctx.currentPage
         })
         ag.hideLoading()
 
         if (code === 0) {
             ctx.rowData = data.data_info || [];
             ctx.total = data.page_count
         }
     }
 
 }